import { render, staticRenderFns } from "./Or.vue?vue&type=template&id=15ac3818&"
import script from "./Or.vue?vue&type=script&lang=js&"
export * from "./Or.vue?vue&type=script&lang=js&"
import style0 from "./Or.vue?vue&type=style&index=0&id=15ac3818&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports